import React from "react";
import BulkUploadIncentiveMultiplier from "../../components/BulkUploadIncentiveMultiplier"

const BulkUploadIncentiveMultiplierManager = (props) => {
  return <BulkUploadIncentiveMultiplier/>
};

export default BulkUploadIncentiveMultiplierManager;